import { TranslationKeys } from './locales';

export const vi: TranslationKeys = {
  common: {
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    close: 'Đóng',
    save: 'Lưu',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    search: 'Tìm kiếm',
    loading: 'Đang tải',
    noData: 'Không có dữ liệu',
    yes: 'Có',
    no: 'Không',
    all: 'Tất cả',
    yearUnit: 'năm',
    register: 'Đăng ký',
    casesUnit: 'trường hợp',
  },
  
  login: {
    title: 'Đăng nhập',
    id: 'Tên đăng nhập',
    password: 'Mật khẩu',
    loginButton: 'Đăng nhập',
    findId: 'Tìm tên đăng nhập',
    findPassword: 'Tìm mật khẩu',
    idPlaceholder: 'Vui lòng nhập tên đăng nhập của bạn.',
    passwordPlaceholder: 'Vui lòng nhập mật khẩu của bạn.',
    keepLoggedIn: 'Giữ đăng nhập',
    invalidCredentials: 'Thông tin tài khoản không hợp lệ. <br /> Vui lòng kiểm tra tên đăng nhập và mật khẩu của bạn!',
  },
  
  dashboard: {
    title: 'Bảng điều khiển',
    farmMachineryCount: 'Nông cụ trên bản đồ',
    totalMachinery: 'Tổng số',
    unit: '',
    runningMachinery: 'Đang chạy',
    stoppedMachinery: 'Đã dừng',
    map: 'Bản đồ',
    list: 'Danh sách',
  },
  
  control: {
    title: 'Kiểm soát tai nạn nông cụ',
    farmMachineryOnMap: 'Nông cụ trên bản đồ',
    searchPlace: 'Nhập địa điểm hoặc địa chỉ',
    placeAddress: 'Địa điểm/Địa chỉ',
    normal: 'Thường',
    cadastral: 'Bản đồ địa chính',
    satellite: 'Vệ tinh',
    eventDate: 'Ngày sự kiện',
    deviceName: 'Tên thiết bị',
    owner: 'Chủ sở hữu',
    status: 'Trạng thái',
    running: 'Đang chạy',
    stopped: 'Đã dừng',
    noData: 'Không có dữ liệu',
    realtimeDetectionHistory: 'Lịch sử phát hiện thời gian thực',
    farmMachineryList: 'Danh sách nông cụ',
    searchedFarmMachinery: 'Nông cụ đã tìm kiếm',
    resultsPerPage: 'Số kết quả mỗi trang',
    realtimeOperationStatus: 'Trạng thái hoạt động thời gian thực',
    danger: 'Nguy hiểm',
    caution: 'Cảnh báo',
    operating: 'Đang hoạt động',
    notOperating: 'Không hoạt động',
    rolloverAccident: 'Tai nạn lật xe',
    searchDeviceOwner: 'Tìm kiếm theo tên thiết bị hoặc chủ sở hữu',
    lastOperation: 'Hoạt động cuối cùng',
    dangerAccident: 'Nguy hiểm (Tai nạn lật xe)',
    deviceList: 'Danh sách thiết bị',
    noDeviceFound: 'Không tìm thấy thiết bị',
    selectDetectionType: 'Chọn loại phát hiện',
    selectDeviceType: 'Chọn loại thiết bị',
    totalFarmMachinery: 'Tổng nông cụ',
    checkDate: 'Vui lòng kiểm tra ngày.',
    selectBothDates: 'Vui lòng chọn cả ngày bắt đầu và ngày kết thúc.',
    group: 'Nhóm',
    noRecord: 'Không có bản ghi lái xe',
    operationRecord: 'Bản ghi hoạt động',
    user: 'Người dùng',
    unlockRolloverStatus: 'Bạn có muốn mở khóa trạng thái lật xe không?',
    unlockRolloverContent: 'Nếu mở khóa, trạng thái phát hiện tai nạn sẽ được xử lý bình thường.\nSau khi xử lý bình thường, không thể hủy.',
    confirmUnlock: 'Có, mở khóa',
    openContact: 'Bạn có muốn xem thông tin liên hệ không?',
    protectingPrivacy: 'Chúng tôi đang bảo vệ thông tin cá nhân của người thuê.',
    openLesseeContact: 'Bạn có muốn xem thông tin liên hệ của người thuê không?',
    openContactButton: 'Xem thông tin liên hệ',
    protectDevicePrivacy: (item: string) => `Để bảo vệ thông tin cá nhân của thiết bị ${item}`,
    enterOfficerName: 'Vui lòng nhập tên chính xác của nhân viên xem thông tin liên hệ.',
    accidentDetected: (minutes: number, seconds: number) => `[ ${minutes} phút ${seconds} giây đã trôi qua sau khi phát hiện tai nạn ]`,
    farmMachineryUsageReport: 'Báo cáo sử dụng máy nông nghiệp',
    accidentDetectionRelease: 'Giải phóng phát hiện tai nạn',
    accidentDetectionReleaseReason: 'Vui lòng chọn lý do giải phóng phát hiện',
    accidentDetectionReleaseReasonDesc: 'Để hiểu tình hình của tai nạn được phát hiện,\nvui lòng chọn lý do giải phóng chính xác.\nThông tin giải phóng có thể được xem trong [Lịch sử phát hiện].',
    accidentDetectionReleaseReasonDesc2: 'Để hiểu tình hình của tai nạn được phát hiện,',
    accidentDetectionReleaseReasonDesc3: 'vui lòng chọn lý do giải phóng chính xác.\nThông tin giải phóng có thể được xem trong [Lịch sử phát hiện].',
    accidentDetectionReleaseButton: 'Giải phóng phát hiện',
    accidentOccurred: 'Tai nạn xảy ra',
    dangerousDriving: 'Lái xe nguy hiểm',
    areaExit: 'Rời khỏi khu vực',
    dangerousAreaEntry: 'Vào khu vực nguy hiểm',
    batteryLow: 'Pin yếu',
    engineAbandonment: 'Bỏ rơi động cơ',
    rolloverAccidentDetected: 'Đã phát hiện tai nạn lật xe.',
    checkUserSafetyImmediately: 'Vui lòng kiểm tra an toàn của người dùng ngay lập tức!',
    // 농기계 사용 리포트 관련
    usageReportTitle: (name: string) => `Báo cáo sử dụng máy nông nghiệp của ${name}`,
    closeReportConfirm: 'Bạn có muốn đóng báo cáo không?',
    deviceOperationStartDateMessage: 'Ngày bắt đầu vận hành của thiết bị đã được truy xuất.',
    currentLocationError: 'Không thể truy xuất vị trí hiện tại.',
    addressLookupError: 'Lỗi tra cứu địa chỉ:',
    ownedDeviceList: 'Danh sách thiết bị sở hữu',
    recentOperationHistory: 'Lịch sử vận hành gần đây',
    operationEndLocation: 'Vị trí kết thúc vận hành:',
    noRecentOperationHistory: 'Không có lịch sử vận hành gần đây.',
    viewMap: 'Xem bản đồ',
    viewOperationHistory: 'Xem lịch sử vận hành',
    operationRunning: 'Đang vận hành',
    operationEnd: 'Kết thúc vận hành',
    // 소유자 정보 관련
    ownerInfo: 'Thông tin chủ sở hữu',
    ownerLabel: 'Chủ sở hữu',
    ownerContact: 'Liên hệ chủ sở hữu',
    currentLocation: 'Vị trí hiện tại',
    contactViewConfirm: 'Bạn có muốn xem liên hệ không?',
    contactViewContent: (item: string) => `Để bảo vệ quyền riêng tư của thiết bị ${item},\nvui lòng nhập tên chính xác của người thực hiện.`,
    contactViewButton: 'Xem liên hệ',
    contactViewPlaceholder: 'Vui lòng nhập tên của người thực hiện.',
    // 운행 관련
    lastOperationTime: 'Vận hành cuối',
    noOperationRecord: 'Không có bản ghi vận hành',
    // 차트 관련
    noDetectionInPeriod: 'Không có lịch sử phát hiện trong khoảng thời gian này.',
    pleaseReselectDate: 'Vui lòng chọn lại ngày.',
    // 기기 정보 모달 관련
    rentalPurpose: 'Mục đích thuê',
    // 운행 기록 관련
    travelDistance: 'Khoảng cách di chuyển',
    farmMachineryVoltage: 'Điện áp máy nông nghiệp',
    angle: 'Góc',
    addressUnavailable: 'Không thể xác nhận địa chỉ.',
    operationLabel: 'Vận hành',
    degreeUnit: 'độ',
    currentStatus: 'Trạng thái hiện tại',
    dailyInspectionRequiredMachineryList: 'Danh sách máy nông nghiệp cần kiểm tra hôm nay',
    // 상태 관련
    statusNormal: 'Bình thường',
    statusCaution: 'Cảnh báo',
    statusDanger: 'Nguy hiểm',
    vehicleRollover: 'Lật xe',
    // 기기 정보 관련
    deviceType: 'Loại thiết bị',
    // 감지 종류 (필터용)
    all: 'Tất cả',
    vehicleRolloverEvent: 'Lật xe',
    dangerousDrivingEvent: 'Lái xe nguy hiểm',
    engineAbandonmentEvent: 'Bỏ quên động cơ',
    areaExitEvent: 'Ra ngoài phạm vi',
    batteryLowEvent: 'Pin yếu',
    theftDetection: 'Phát hiện trộm cắp',
    dangerousAreaEntryEvent: 'Vào khu vực nguy hiểm',
    // 기기 종류 (필터용)
    tractor: 'Máy kéo',
    speedSprayer: 'Máy phun tốc độ',
    fourWheelMotorcycle: 'Xe máy bốn bánh',
    twoWheelMotorcycle: 'Xe máy hai bánh',
    oneTonTruck: 'Xe tải 1 tấn',
    walkingManagement: 'Máy quản lý đi bộ',
    ridingManagement: 'Máy quản lý cưỡi',
    agriculturalHighWorkVehicle: 'Xe làm việc trên cao nông nghiệp',
    agriculturalTransportVehicle: 'Xe vận chuyển nông nghiệp',
    agriculturalLoader: 'Xe tải nông nghiệp',
    ridingWeedCutter: 'Máy cắt cỏ cưỡi',
    ridingWeedRemover: 'Máy làm cỏ cưỡi',
    ridingTransplanter: 'Máy cấy cưỡi',
    fertilizerSpreader: 'Máy rải phân bón',
    pesticideSpreader: 'Máy phun thuốc trừ sâu',
    combine: 'Máy gặt đập liên hợp',
    excavator: 'Máy đào',
    cultivator: 'Máy cày',
    branchCrusher: 'Máy nghiền cành',
    etc: 'Khác',
  },
  
  history: {
    title: 'Truy vấn lịch sử phát hiện',
    detectionTime: 'Thời gian phát hiện',
    eventType: 'Loại sự kiện',
    deviceName: 'Tên thiết bị',
    owner: 'Chủ sở hữu',
    dateRange: 'Khoảng ngày',
    from: 'Từ ngày',
    to: 'Đến ngày',
    searchedDetections: 'Lịch sử phát hiện đã tìm kiếm',
    detectionNumber: 'Số phát hiện',
    deviceType: 'Loại thiết bị',
    deviceName2: 'Tên thiết bị',
    detectionDetails: 'Chi tiết phát hiện',
    detectedDateTime: 'Ngày/Giờ phát hiện',
    releasedDateTime: 'Ngày/Giờ giải phóng',
    releaseReason: 'Lý do giải phóng',
    actionTakenBy: 'Người xử lý',
    detectionDetailView: 'Xem chi tiết phát hiện',
    noDataAvailable: 'Không tìm thấy dữ liệu.',
    noLocationData: 'Không thể xác định vị trí của dữ liệu này.',
    downloadHistory: 'Tải xuống lịch sử',
    selectDeviceType: 'Chọn loại thiết bị',
    selectDetectionType: 'Chọn loại phát hiện',
    searchDeviceOwner: 'Tìm kiếm tên thiết bị hoặc tên chủ sở hữu',
    casesUnit: 'trường hợp',
    lastOperation: 'Hoạt động cuối cùng',
    distance: 'Khoảng cách di chuyển',
    machineryVoltage: 'Điện áp nông cụ',
    currentStatus: 'Trạng thái hiện tại',
    normal: 'Bình thường',
    detectionDetails2: 'Chi tiết phát hiện',
    detectionDateTime: 'Ngày/Giờ phát hiện',
    detectionLocation: 'Vị trí phát hiện',
    releaseReason2: 'Lý do giải phóng',
    user2: 'Người dùng',
    userContact: 'Liên hệ người dùng',
    guardian: 'Người giám hộ',
    guardianContact: 'Liên hệ người giám hộ',
    guardianUserRelation: 'Mối quan hệ người giám hộ-người dùng',
    operating: 'Đang vận hành',
    deviceTypeLabel: 'Loại thiết bị',
  },
  
  manageUser: {
    title: 'Quản lý người dùng',
    userList: 'Danh sách người dùng',
    addUser: 'Thêm người dùng',
    editUser: 'Chỉnh sửa người dùng',
    deleteUser: 'Xóa người dùng',
    register: 'Đăng ký tài khoản',
    permissionManagement: 'Quản lý quyền tài khoản',
    cancelRegisterTitle: 'Hủy đăng ký người dùng?',
    cancelRegisterContent: 'Nhấn xác nhận sẽ đặt lại nội dung đã nhập.',
    userName: 'Tên người dùng',
    phone: 'Số điện thoại',
    email: 'Email',
    area: 'Nhóm',
    grade: 'Cấp độ',
    status: 'Trạng thái',
    searchUser: 'Tìm kiếm theo ID hoặc tên người dùng',
    userAccountInfo: 'Thông tin tài khoản người dùng',
    myAccountInfo: 'Thông tin tài khoản của tôi',
    confirmDelete: 'Bạn có muốn xóa tài khoản này không?',
    deleteWarning: 'Người dùng sẽ không thể sử dụng tài khoản này nữa,\nvà thông tin tài khoản đã xóa không thể khôi phục.',
    accountName: 'Tên tài khoản',
    userId: 'ID',
    contact: 'Liên hệ',
    address: 'Địa chỉ',
    detailAddress: 'Địa chỉ chi tiết',
    accountCreationDate: 'Ngày tạo tài khoản',
    viewDetails: 'Xem chi tiết',
    viewContactRecord: 'Xem lịch sử liên hệ',
    recordsFound: 'Bản ghi tìm thấy',
    category: 'Phân loại',
    contactViewTime: 'Thời gian xem liên hệ',
    reader: 'Người xem',
    deleteAccount: 'Xóa tài khoản',
    resetPassword: 'Đặt lại mật khẩu',
    noDataFound: 'Không tìm thấy dữ liệu.',
    deleteMessage: 'Bạn có chắc chắn muốn xóa?',
    searchPlaceholder: 'Tìm kiếm',
    peopleUnit: 'người',
    // Thêm khóa
    passwordConfirm: 'Xác nhận mật khẩu',
    maxCharacters: 'Tối đa 20 ký tự',
    passwordRequirements: '8+ ký tự bao gồm ký tự đặc biệt',
    emailExample: 'vd. test123@nongcall.com',
    phoneExample: 'vd. 010-1234-1234 / 031-123-1234',
    postcodeSearch: 'Tìm mã bưu điện',
    clear: 'Xóa',
    accountNamePlaceholder: 'Nhập tên tổ chức sử dụng hệ thống điều khiển (tối đa 20 ký tự)',
    addressPlaceholder: 'Nhập địa chỉ tổ chức sử dụng hệ thống điều khiển',
    userImageAlt: 'Hình ảnh người dùng',
    // Thêm placeholder keys
    emailMaxCharacters: 'Tối đa 50 ký tự',
    phoneIncludeDash: 'Bao gồm dấu gạch ngang khi nhập',
    detailAddressMaxCharacters: 'Tối đa 100 ký tự',
    // Phần quản lý quyền
    detectionNotification: 'Thông báo tình trạng phát hiện',
    functionManagement: 'Quản lý chức năng',
    dangerAccident: 'Nguy hiểm (Tai nạn)',
    warningDangerousArea: 'Cảnh báo (Vào khu vực nguy hiểm)',
    batteryAbnormal: 'Pin bất thường',
    areaExit: 'Ra ngoài phạm vi',
    detectionRelease: 'Xử lý hủy phát hiện',
    deviceInfoModify: 'Sửa đổi thông tin thiết bị',
    // Đặt lại mật khẩu
    resetPasswordTitle: 'Đặt lại mật khẩu?',
    resetPasswordContent: 'Mật khẩu sẽ được đặt lại khi bạn nhấn xác nhận.',
    // Modal xem liên hệ
    openContact: 'Bạn có muốn xem liên hệ không?',
    protectingPrivacy: 'Để bảo vệ thông tin cá nhân của người dùng,\nvui lòng nhập chính xác tên của người xem.',
    openContactButton: 'Xem liên hệ',
    enterOfficerName: 'Vui lòng nhập tên người xem.',
    // Hiển thị liên hệ
    noContact: 'Không có liên lạc',
    viewContact: 'Xem liên hệ',
    // Modal trang cá nhân
    viewAccountInfo: 'Bạn có muốn xem thông tin tài khoản không?',
    enterPasswordForPrivacy: 'Để bảo vệ thông tin cá nhân,\nvui lòng nhập mật khẩu tài khoản.',
    enterPasswordPlaceholder: 'Vui lòng nhập mật khẩu.',
    confirming: 'Đang xác nhận...',
  },
  
  manageNok: {
    title: 'Quản lý người nhận bổ sung',
    nokList: 'Danh sách người nhận bổ sung',
    addNok: 'Thêm người nhận bổ sung',
    editNok: 'Chỉnh sửa người nhận bổ sung',
    deleteNok: 'Xóa người nhận bổ sung',
    nokName: 'Tên',
    relationship: 'Quan hệ',
    phone: 'Số điện thoại',
    priority: 'Ưu tiên',
    // Trang quản lý người nhận bổ sung
    recipientInfo: 'Thông tin người nhận thông báo bổ sung',
    recipientContact: 'Liên hệ người nhận bổ sung',
    ownerName: 'Tên chủ sở hữu',
    ownerContact: 'Liên hệ chủ sở hữu',
    accountCreationTime: 'Thời gian tạo tài khoản',
    viewDetailInfo: 'Xem chi tiết',
    deleteAccount: 'Xóa tài khoản',
    searchPlaceholder: 'Tìm kiếm theo ID hoặc tên người nhận',
    registerRecipient: 'Đăng ký người nhận bổ sung',
    sortByName: 'Sắp xếp theo tên',
    sortByContact: 'Sắp xếp theo liên hệ người nhận',
    sortByOwnerName: 'Sắp xếp theo tên chủ sở hữu',
    sortByOwnerContact: 'Sắp xếp theo liên hệ chủ sở hữu',
    sortByRelationship: 'Sắp xếp theo quan hệ',
    sortByCreationTime: 'Sắp xếp theo thời gian tạo',
    defaultSort: 'Thứ tự mặc định',
    deleteConfirmTitle: 'Xóa tài khoản này?',
    deleteConfirmContent: 'Thông tin người nhận này sẽ không còn khả dụng,\nvà thông tin đã xóa không thể khôi phục.',
    noDataFound: 'Không tìm thấy dữ liệu.',
    // Modal đăng ký/chỉnh sửa người nhận bổ sung
    registerRecipientTitle: 'Đăng ký người nhận bổ sung',
    registerRecipientSubtitle: 'Chọn chủ sở hữu',
    editRecipientTitle: 'Chỉnh sửa người nhận bổ sung',
    editRecipientSubtitle: 'Chọn chủ sở hữu',
    cancelRegisterTitle: 'Hủy đăng ký?',
    cancelRegisterContent: 'Tất cả thông tin đã nhập sẽ được xóa.',
    selectOwner: 'Chọn chủ sở hữu',
    nameLabel: 'Tên',
    contactLabel: 'Liên hệ',
    ownerLabel: 'Chủ sở hữu',
    relationshipLabel: 'Quan hệ',
    namePlaceholder: 'Tên người nhận',
    contactPlaceholder: 'Chỉ số (tối thiểu 10 chữ số)',
    relationshipPlaceholder: 'Nhập quan hệ',
    contactMinLength: 'Liên hệ phải có ít nhất 10 chữ số.',
    contactOnlyNumbers: 'Liên hệ chỉ được nhập số.',
    registerSuccess: 'Đăng ký người nhận thành công',
    peopleUnit: 'người',
    // Modal chi tiết/chỉnh sửa người nhận
    detailInfoTitle: 'Chi tiết người nhận',
    editInfoTitle: 'Chỉnh sửa chi tiết người nhận',
    editSuccess: 'Chỉnh sửa người nhận thành công',
    cancelEditTitle: 'Hủy chỉnh sửa người nhận?',
    cancelEditContent: 'Tất cả thông tin đã nhập sẽ được xóa.',
    editComplete: 'Hoàn thành chỉnh sửa',
    maxCharacters: 'Tối đa 20 ký tự',
    includeDash: 'Bao gồm dấu gạch ngang khi nhập.',
  },
  
  manageCustomer: {
    title: 'Quản lý khách hàng',
    customerList: 'Danh sách khách hàng',
    addCustomer: 'Thêm khách hàng',
    editCustomer: 'Chỉnh sửa khách hàng',
    deleteCustomer: 'Xóa khách hàng',
    customerName: 'Tên khách hàng',
    phone: 'Điện thoại',
    memo: 'Ghi chú',
    // Trang quản lý khách hàng
    ownerInfo: 'Thông tin khách hàng',
    ownerNumber: 'Số khách hàng',
    contact: 'Liên hệ',
    name: 'Tên',
    address: 'Địa chỉ',
    detailAddress: 'Địa chỉ chi tiết',
    group: 'Nhóm',
    viewDetailInfo: 'Xem chi tiết',
    deleteAccount: 'Xóa tài khoản',
    searchPlaceholder: 'Tìm kiếm theo ID hoặc tên khách hàng',
    registerOwner: 'Đăng ký khách hàng',
    sortByNumber: 'Sắp xếp theo số',
    sortByContact: 'Sắp xếp theo liên hệ',
    sortByName: 'Sắp xếp theo tên',
    sortByAddress: 'Sắp xếp theo địa chỉ',
    sortByDetailAddress: 'Sắp xếp theo địa chỉ chi tiết',
    sortByGroup: 'Sắp xếp theo nhóm',
    defaultSort: 'Thứ tự mặc định',
    deleteConfirmTitle: 'Xóa tài khoản này?',
    deleteConfirmContent: 'Khách hàng sẽ không thể sử dụng tài khoản này nữa,\nvà thông tin tài khoản đã xóa không thể khôi phục.',
    noDataFound: 'Không tìm thấy dữ liệu.',
    peopleUnit: 'người',
    casesUnit: 'trường hợp',
    noAddress: 'Không có địa chỉ',
    noGroup: 'Không có nhóm',
    noDetailAddress: 'Không có địa chỉ chi tiết',
    detailAddressLabel: 'Địa chỉ chi tiết',
    // Modal chi tiết khách hàng
    detailInfoTitle: 'Chi tiết khách hàng',
    editInfoTitle: 'Chỉnh sửa khách hàng',
    ownerName: 'Tên khách hàng',
    ownerContact: 'Liên hệ khách hàng (ID)',
    password: 'Mật khẩu',
    joinDate: 'Ngày tham gia',
    other: 'Khác',
    groupLabel: 'Nhóm',
    // Modal chỉnh sửa khách hàng
    modifyInfoTitle: 'Chỉnh sửa chi tiết khách hàng',
    modifyComplete: 'Hoàn thành chỉnh sửa',
    cancelModifyTitle: 'Hủy chỉnh sửa khách hàng?',
    cancelModifyContent: 'Nội dung đã nhập sẽ được đặt lại khi bạn nhấn xác nhận.',
    invalidPassword: 'Mật khẩu không hợp lệ.',
    passwordSpaceError: 'Mật khẩu không thể chứa khoảng trắng.',
    passwordRequirements: 'Phải bao gồm ít nhất một chữ cái, số và ký tự đặc biệt,\nvà có ít nhất 8 ký tự.',
    maxCharacters20: 'Tối đa 20 ký tự',
    maxCharacters100: 'Tối đa 100 ký tự',
    includeDash: 'Bao gồm dấu gạch ngang khi nhập.',
    addressPlaceholder: 'Địa chỉ',
    passwordPlaceholder: 'Chữ cái, số, ký tự đặc biệt, 8+ ký tự',
    groupSrLabel: 'Tổ chức',
    // 연락처 관련
    noContact: 'Không có liên lạc',
    viewContact: 'Xem liên lạc',
    // Modal đăng ký khách hàng
    registerInfoTitle: 'Đăng ký khách hàng',
    registerComplete: 'Đăng ký',
    cancelRegisterTitle: 'Hủy đăng ký khách hàng?',
    cancelRegisterContent: 'Nội dung đã nhập sẽ được đặt lại khi bạn nhấn xác nhận.',
    registerSuccess: 'Đăng ký khách hàng thành công',
    numbersOnly: 'Vui lòng chỉ nhập số.',
    otherPlaceholder: 'Nhập khác',
    noDashNumbers: 'Chỉ số không có dấu gạch ngang',
  },
  
  manageMobility: {
    title: 'Quản lý nông cụ',
    mobilityList: 'Danh sách nông cụ',
    addMobility: 'Thêm nông cụ',
    mobilityName: 'Tên nông cụ',
    mobilityType: 'Loại nông cụ',
    owner: 'Chủ sở hữu',
    status: 'Trạng thái',
  },
  
  mobileList: {
    title: 'Quản lý nông cụ',
    searchDeviceOwner: 'Tìm kiếm tên thiết bị hoặc tên chủ sở hữu',
    from: 'Ngày bắt đầu',
    to: 'Ngày kết thúc',
    selectDeviceType: 'Chọn loại thiết bị',
    selectDetectionType: 'Chọn loại phát hiện',
    group: 'Nhóm',
    registerDevice: 'Đăng ký thiết bị',
    searchedDevices: 'Thiết bị đã tìm kiếm',
    unit: 'Đơn vị',
    deviceName: 'Tên thiết bị',
    deviceType: 'Loại thiết bị',
    owner: 'Chủ sở hữu',
    operationStatus: 'Trạng thái\nvận hành',
    lastOperationDate: 'Thời gian vận hành\ngần nhất',
    terminalSN: 'Thiết bị cuối\nS/N',
    machineryBattery: 'Bat nông\ncụ',
    terminalBattery: 'Bat thiết bị\ncuối',
    testMode: 'Chế độ\nkiểm tra',
    deviceDetail: 'Thông tin chi tiết thiết bị',
    viewOnMap: 'Xem trên bản đồ',
    deviceDelete: 'Xóa thiết bị',
    testModeActivate: 'Bạn có muốn thay đổi trạng thái chế độ không?',
    testModeDeactivate: 'Bạn có muốn hủy chế độ kiểm tra không?',
    testModeActivateContent: 'Nếu thay đổi sang chế độ kiểm tra,\nbạn sẽ không nhận được thông báo tai nạn của thiết bị này,\nvà có thể nhận lại sau khi chế độ kiểm tra được hủy.',
    testModeDeactivateContent: 'Nếu hủy chế độ kiểm tra,\nthiết bị này có thể xảy ra thông báo tai nạn.',
    deleteDevice: 'Bạn có muốn xóa thiết bị này không?',
    deleteDeviceContent: 'Nếu xóa thiết bị, bạn sẽ không thể xác nhận thông tin của thiết bị này,\nthông tin thiết bị đã xóa không thể khôi phục.',
    confirmDelete: 'Xóa',
    exportInstallHistory: 'Xuất lịch sử cài đặt',
    exportCount: 'Trường hợp',
    noRecord: 'Không có bản ghi vận hành',
    inspectionNeeded: 'Cần kiểm tra thiết bị cuối.',
    clipboardCopied: 'Đã sao chép vào clipboard.',
    noDownloadAvailable: 'Không có tệp có thể tải xuống.',
    downloadSuccess: 'Tải xuống tệp thành công',
  },
  
  deviceRegister: {
    title: 'Đăng ký thiết bị',
    deviceName: 'Tên thiết bị',
    deviceNamePlaceholder: 'Tối đa 20 ký tự',
    owner: 'Chủ sở hữu',
    ownerPlaceholder: 'Vui lòng chọn chủ sở hữu',
    selectOwner: 'Chủ sở hữu',
    deviceType: 'Loại thiết bị',
    terminalSerialNumber: 'Số sê-ri thiết bị cuối',
    terminalSerialPlaceholder: 'Mặc định 8 ký tự ~ Tối đa 16 ký tự',
    terminalIMEI: 'IMEI thiết bị cuối',
    terminalIMEIPlaceholder: '15 chữ số',
    numbersOnly: 'Vui lòng chỉ nhập số.',
    confirmRegister: 'Bạn có muốn đăng ký nông cụ không?',
    confirmRegisterContent: 'Nội dung đã đăng ký có thể được sửa đổi sau.',
    confirmRegisterButton: 'Đăng ký',
    cancelRegister: 'Bạn có muốn hủy đăng ký thiết bị không?',
    cancelRegisterContent: 'Nếu xác nhận, nội dung đã nhập sẽ được khởi tạo lại.',
    checkInput: 'Vui lòng kiểm tra lại đầu vào.',
    registerCancel: 'Hủy',
    registerButton: 'Đăng ký',
    registerLoading: 'Đăng ký',
    noRegisterButton: 'Đăng ký',
    ownerRequired: 'Vui lòng chọn chủ sở hữu.',
    ownerError: 'Không thể chọn dữ liệu này.',
    imageUploadSuccess: 'Tải lên hình ảnh người dùng thành công',
    imageUploadError: 'Đã xảy ra lỗi trong quá trình đăng ký hình ảnh.',
    bulkUploadTitle: 'Vui lòng tải lên tệp Excel thông tin thiết bị.',
    bulkUploadContent: 'Vui lòng tải lên tệp Excel có thông tin đăng ký thiết bị.\nĐể đăng ký thiết bị chính xác, vui lòng chỉ sử dụng tệp được viết theo mẫu.',
  },
  
  deviceDetail: {
    title: 'Thông tin chi tiết thiết bị',
    titleEdit: 'Sửa đổi thông tin thiết bị',
    deviceName: 'Tên thiết bị',
    owner: 'Chủ sở hữu',
    ownerPlaceholder: 'Vui lòng chọn chủ sở hữu',
    ownerSelect: 'Chủ sở hữu',
    registrationDate: 'Thời gian đăng ký thiết bị',
    deviceType: 'Loại thiết bị',
    terminalSerialNumber: 'Số sê-ri thiết bị cuối',
    terminalIMEI: 'IMEI thiết bị cuối',
    modifyDevice: 'Sửa đổi',
    modifyComplete: 'Hoàn thành',
    cancelModify: 'Bạn có muốn hủy sửa đổi thông tin thiết bị không?',
    cancelModifyContent: 'Nếu xác nhận, nội dung đã sửa đổi sẽ được khởi tạo lại.',
    ownerRequired: 'Vui lòng chọn chủ sở hữu.',
    ownerError: 'Không thể chọn dữ liệu này.',
    numbersOnly: 'Vui lòng chỉ nhập số.',
    save: 'Lưu',
    reset: 'Hủy',
    installPhotos: 'Ảnh cài đặt',
    overallView: 'Toàn cảnh nông cụ',
    terminalInstallation: 'Hình ảnh cài đặt thiết bị cuối',
    terminalSerialSticker: 'Nhãn dán số sê-ri thiết bị cuối',
    powerWiringStatus: 'Trạng thái dây cáp nguồn',
    machineryTypePlate: 'Biển hiệu loại nông cụ',
    userPhoto: 'Ảnh người dùng',
    noImage: 'Không có hình ảnh.',
  },
  
  eventTypes: {
    accident: 'Lật xe',
    battery: 'Pin yếu',
    dangerous: 'Vào khu vực nguy hiểm',
    userArea: 'Rời khu vực sử dụng',
    emergency: 'Cuộc gọi khẩn cấp',
    keyOn: 'Để trống',
  },
  
  status: {
    normal: 'Bình thường',
    warning: 'Cảnh báo',
    error: 'Lỗi',
    running: 'Đang chạy',
    stopped: 'Đã dừng',
    idle: 'Chờ',
  },
  
  navigation: {
    home: 'Trang chủ',
    accidentControl: 'Kiểm soát tai nạn',
    detectionHistory: 'Lịch sử phát hiện',
    statistics: 'Thống kê',
    notice: 'Thông báo',
    management: 'Quản lý',
    farmMachineryManagement: 'Quản lý nông cụ',
    userAccountManagement: 'Quản lý tài khoản người dùng',
    ownerManagement: 'Quản lý chủ sở hữu',
    additionalRecipientManagement: 'Quản lý người nhận bổ sung',
    sitemap: 'Sơ đồ trang web',
    shopZone: 'Vùng an toàn văn phòng cho thuê',
    shopZoneMap: 'Bản đồ vùng an toàn',
    shopZoneAlarms: 'Cảnh báo bị chặn',
    bigdata: 'Phân tích dữ liệu lớn',
    logout: 'Đăng xuất',
    honorific: 'bạn',
  },
  
  notice: {
    title: 'Thông báo',
    goBack: 'Quay lại danh sách',
    confirm: 'Xác nhận',
    edit: 'Chỉnh sửa',
    editContent: 'Chỉnh sửa nội dung',
    delete: 'Xóa',
    deleteTitle: 'Bạn có muốn xóa thông báo không?',
    deleteContent: 'Thông báo đã xóa sẽ không hiển thị cho chủ sở hữu và không thể khôi phục.',
    register: 'Đăng ký thông báo',
    noNotice: 'Không có thông báo đã đăng ký.',
    previousNotice: 'Thông báo trước',
    nextNotice: 'Thông báo tiếp theo',
    new: 'Mới',
    web: 'WEB',
    app: 'APP',
    write: 'Viết thông báo',
    editTitle: 'Chỉnh sửa thông báo',
    category: 'Danh mục thông báo',
    noticeTitle: 'Tiêu đề thông báo',
    titlePlaceholder: 'Nhập tiêu đề (tối đa 100 ký tự)',
    cancel: 'Hủy',
    complete: 'Hoàn thành',
    registerConfirm: 'Bạn có muốn đăng ký thông báo không?',
    registerContent: 'Nội dung thông báo có thể được chỉnh sửa hoặc xóa,\nvà thông báo đã đăng ký có thể được xem bởi chủ sở hữu.',
    cancelConfirm: 'Bạn có muốn quay lại danh sách không?',
    cancelContent: 'Nếu bạn nhấp xác nhận,\nnội dung viết cho đến nay sẽ không được lưu.',
    editBreadcrumb: 'Chỉnh sửa thông báo',
    detailBreadcrumb: 'Chi tiết thông báo',
    contentPlaceholder: 'Vui lòng nhập nội dung thân bài (tối đa 2000 ký tự)',
    imageFormatInfo: '* Các định dạng tệp hình ảnh có thể đính kèm là png, jpg, jpeg.',
    imageSizeInfo: '* Giới hạn kích thước của một tệp hình ảnh là 5MB và tối đa 5 tệp có thể được đính kèm.',
    maxLengthExceeded: 'Vượt quá 2000 ký tự.',
    invalidFileFormat: 'Vui lòng kiểm tra định dạng tệp.\nCác định dạng tệp có thể tải lên là png, jpg, jpeg.',
    maxImagesExceeded: 'Bạn chỉ có thể đính kèm tối đa 5 hình ảnh.',
    maxSizeExceeded: 'Mỗi tệp hình ảnh giới hạn tối đa 5MB.',
    confirmTitle: 'Vui lòng kiểm tra nội dung.',
  },
  
  statistics: {
    title: 'Thống kê lịch sử phát hiện',
    search: 'Tìm kiếm',
    download: 'Tải xuống',
    invalidPeriod: 'Vui lòng chọn khoảng thời gian\n7 ngày trở lên.',
    noData: 'Không có hồ sơ trong khoảng thời gian này.\nVui lòng chọn ngày khác.',
    monthView: 'Xem theo tháng',
    operatedMachinery: 'Nông cụ đã vận hành',
    totalMachinery: 'Tổng nông cụ',
    dailyDetections: 'Lịch sử phát hiện theo ngày (trường hợp)',
    periodDetections: 'Lịch sử phát hiện trong khoảng thời gian (%)',
    hourlyDetections: 'Lịch sử phát hiện theo giờ (trường hợp)',
    detectByType: 'Lịch sử phát hiện theo loại',
    detectList: 'Danh sách lịch sử phát hiện',
    totalDetections: 'Tổng số phát hiện',
    rolloverDetections: 'Phát hiện tai nạn lật xe',
    dangerousDrivingDetections: 'Phát hiện lái xe nguy hiểm',
    outOfAreaDetections: 'Phát hiện rời khu vực sử dụng',
    batteryAnomalyDetections: 'Phát hiện bất thường pin',
    ignitionNeglectDetections: 'Phát hiện bỏ qua đánh lửa',
    cases: 'trường hợp',
    units: 'đơn vị',
    selectPeriod: 'Chọn thời gian',
    selectPeriodPlaceholder: '-- Chọn thời gian --',
    oneMonth: '1 tháng',
    threeMonths: '3 tháng',
    sixMonths: '6 tháng',
    oneYear: '1 năm',
    timeUnit: '(Đơn vị: Giờ)',
    monthlyDetections: 'Lịch sử phát hiện theo tháng (trường hợp)',
    dailyView: 'Xem theo ngày',
    detectionHistory: 'Lịch sử phát hiện',
    dayOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    dangerousAreaEntryDetections: 'Phát hiện vào khu vực nguy hiểm',
    user: 'Người dùng',
    lastOperation: 'Hoạt động cuối',
    noDrivingRecord: 'Không có bản ghi lái xe',
  },
};

